import React from 'react';
import TinyPlAdjustments from 'views/tiny/TinyPlAdjustments.js';

function TinyPlAdjustmentsContainer() {
  return <TinyPlAdjustments />;
}

export default TinyPlAdjustmentsContainer;
